/**
 * Simple popup component to display info text, can be followed by a link.
 * 
 * Properties:
 * 
 *      left:               string, css attribute "left"
 *      top:                string, css attribute "top"
 *      link:               string, href-html-attribute
 *      icon:               string, class name of icon to be displayed
 *      linkValue:          string, value of popup element is attribute in handler
 *      linkText:           string, text for link (can be both text followed by icon)
 *      text:               string, text to be displayed that is not part of a link
 *      onClickHandler:     function, callback to trigger if link is #
 *      onCloseHandler:     function, callback when popup has been closed
 */

import React from "react";

const Popup = (props:any) => {

    console.log("props: ",props);
    
    return (
        <div className="inb-react-popup" style={{left:props.left,top:props.top}}>
            <div className="inb-react-popup-header">
                <span className="inb-react-popup-close" onClick={() => {props.onCloseHandler()} }>x</span>
            </div>
            <span className="row">{props.text ? props.text : ''}</span>
            {props.link &&
                <a href={props.link} onClick={props.link === '#' ? () => {props.onClickHandler(props.linkValue)} : () => {}}>
                    { props.linkText &&
                        <span>{props.linkText}</span>
                    }
                    { props.icon &&
                        <i className={props.icon}></i>
                    }
                </a>
            }
        </div>
    );
};
export default Popup;